import { purchaseOrderStatus, purchaseOrderBillingStatus } from '../../../Shared/_constants/constants';

// Badge colours shared between the list page and the edit page, so the
// same status always looks the same everywhere it's shown.
export function purchaseStatusClass(status: string): string {
  switch (status) {
    case purchaseOrderStatus.RECEIVED:
      return 'bg-green-100 border border-green-400 text-green-700';
    case purchaseOrderStatus.PARTIALLY_RECEIVED:
      return 'bg-orange-100 border border-orange-400 text-orange-700';
    case purchaseOrderStatus.ORDERED:
      return 'bg-blue-100 border border-blue-400 text-blue-700';
    case purchaseOrderStatus.CANCELLED:
      return 'bg-red-100 border border-red-400 text-red-700';
    case purchaseOrderStatus.DRAFT:
      return 'bg-neutral-100 border border-neutral-400 text-neutral-600';
    default:
      return 'bg-neutral-100 border border-neutral-400 text-neutral-600';
  }
}

// Deliberately a different palette from purchaseStatusClass above (indigo/
// rose/emerald rather than blue/red/green) - the two badges sit side by
// side on the edit page, and reusing the same colours made unrelated
// states (e.g. ORDERED and BILLED, both "in progress" but for different
// reasons) look identical at a glance.
export function billingStatusClass(billingStatus: string): string {
  switch (billingStatus) {
    case purchaseOrderBillingStatus.PAID:
      return 'bg-emerald-100 border border-emerald-400 text-emerald-700';
    case purchaseOrderBillingStatus.BILLED:
      return 'bg-indigo-100 border border-indigo-400 text-indigo-700';
    case purchaseOrderBillingStatus.OVERDUE:
      return 'bg-rose-100 border border-rose-400 text-rose-700';
    case purchaseOrderBillingStatus.UNBILLED:
      return 'bg-neutral-100 border border-neutral-400 text-neutral-600';
    default:
      return 'bg-neutral-100 border border-neutral-400 text-neutral-600';
  }
}
